@let _qaaPrefix = qaaPrefix();
<div class="modal-header">
  <h4
    class="modal-title"
    id="modal-basic-title"
    [attr.data-qaa]="_qaaPrefix + '-title'"
  >
    Firm360 Available Shortcuts
  </h4>
  <button
    type="button"
    [attr.data-qaa]="_qaaPrefix + '-close-button'"
    class="close btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  @for (g of groups; track g) {
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Action</th>
          <th class="text-end">Shortcut</th>
        </tr>
      </thead>
      <tbody>
        @for (h of g.hotkeys; track h) {
          <tr>
            <td>
              {{ h.description }}
            </td>
            <td class="text-end">
              <kbd [innerHTML]="h.keys | hotkeysShortcut"></kbd>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
